import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';



import { AngularSvgIconModule } from 'angular-svg-icon';
// import { HeaderComponent } from '../@shared/components/header/header.component';
import { SharedModule } from '@shared/shared.module';
import { ShellComponent } from './shell.component';
import { SidebarComponent } from './sidebar/sidebar.component';


@NgModule({
    imports: [CommonModule, TranslateModule, RouterModule, AngularSvgIconModule, SharedModule, ShellComponent, SidebarComponent],
})
export class ShellModule {}
